import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import type { AuthState } from "@/auth/auth-provider";
import { env } from "@/config/env";

export interface RouterContext {
  queryClient: QueryClient;
  auth: AuthState;
}

const Devtools = env.isDev
  ? await import("@tanstack/router-devtools").then((m) => m.TanStackRouterDevtools)
  : () => null;

const QueryDevtools = env.isDev
  ? await import("@tanstack/react-query-devtools").then(
      (m) => m.ReactQueryDevtools,
    )
  : () => null;

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      {env.isDev ? (
        <>
          <Devtools position="bottom-right" />
          <QueryDevtools buttonPosition="bottom-left" />
        </>
      ) : null}
    </>
  );
}
